import { gql } from '../../../__generated__/graphql/catalog'

export const SIZE_CHART_FIELDS = gql(`
  fragment sizeChartFields on SizeChartCG {
    columnNames
    columnValues
    imageUri
    name
    navLabel
    tables {
      cells
      measureImage
      measureTips {
        kind
        tip
      }
      sizeTips {
        kind
        tip
      }
      subtitle
      tabLabel
      title
    }
    tips {
      kind
      tip
    }
    title
    video
  }
`)

export const FETCH_SIZE_CHARTS = gql(`
  query FETCH_SIZE_CHARTS($preview: Boolean) {
    siteFixtures(preview: $preview) {
      id
      __typename
      mensSizeCharts {
        ...sizeChartFields
      }
      womensSizeCharts {
        ...sizeChartFields
      }
    }
  }
`)
